import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["application", "visit"]

  select() {
    const visitId = this.applicationTarget.selectedOptions[0]?.dataset.visitId
    if (visitId) this.visitTarget.value = visitId
  }

  visitChanged() {
    const visitId = this.applicationTarget.selectedOptions[0]?.dataset.visitId
    if (visitId && this.visitTarget.value !== visitId) this.applicationTarget.value = ""
  }
}
